import type { FC } from 'react'
import React from 'react'
import TaskDetails from 'redesign/components/templates/task-details'
import type { UseTaskDetailsPageProps } from './types'
import useTaskDetailsPage from './use-task-details-page'

const TaskDetailsPageContent: FC<UseTaskDetailsPageProps> = ({ taskUuid }) => {
  const { task, loading, refetch } = useTaskDetailsPage({ taskUuid })

  if (loading || !task) return null

  return <TaskDetails task={task} refetch={refetch} />
}

export default TaskDetailsPageContent
